<script setup>
import bgHero from '@/assets/img/bg-gradient-smilepicture.png'
import tvCommercial from '@/assets/img/services/our-services-2.png'
import OurProcess from '../../components/OurProcess.vue';
import SomeOfWorks from '../../components/SomeOfWorks.vue';
import { ref, onMounted } from 'vue'
import { fetchWorks } from '@/services/api'
import OurProcess2 from '../../components/OurProcess2.vue';
const loading = ref(false)
const works = ref([])
const meta = ref({})
const fetchWorksData = async () => {
    loading.value = true
    try {
        const result = await fetchWorks({ service_slug: 'company-profile' })
        works.value = result.data
        meta.value = result.meta
    } catch (error) {
        console.error('Failed to fetch works:', error)
        works.value = []
    } finally {
        loading.value = false
    }
}

onMounted(() => {
    fetchWorksData()
})
</script>

<template>
    <!-- HERO SECTION -->
    <section class="video-wrapper px-0 mt-0 min-vh-80 d-flex align-items-center" :style="{
        backgroundImage: `url(${bgHero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    }">
        <div class="container py-14">
            <div class="row gx-md-8 gx-xl-12 gy-10 align-items-center">
                <!-- TEXT -->
                <div class="col-lg-6 text-start text-lg-start">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/services">Services</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Company Profile</li>
                        </ol>
                    </nav>

                    <h1 class="display-2 mb-4 text-secondary">
                        Tell Your Company’s Story, Clearly and Confidently
                    </h1>

                    <p class="lead text-white">
                        A company profile video that presents your identity, values, and vision through compelling
                        visuals and authentic storytelling.
                    </p>
                </div>

                <!-- LOGO -->
                <div class="col-lg-6 d-flex align-items-center justify-content-center">
                    <img class="img-fluid" :src="tvCommercial" :srcset="`${tvCommercial} 2x`"
                        alt="Smile Picture Logo" />
                </div>
            </div>
        </div>
    </section>

    <!-- About TV -->
    <section class="wrapper px-0 bg-black">
        <div class="container pt-10 pb-12 pt-md-14 pb-md-16">
            <div class="row">
                <div class="mx-auto text-white text-center">
                    <h1 class="display-1 mb-3 text-white">
                        About <span style="color: #ffae0b;">Company Profile Services</span>
                    </h1>

                    <p class="lead">
                        A Company Profile Video is a powerful visual tool to introduce who you are, what you do, and
                        what you stand for.
                        It helps companies communicate their brand story in a clear, engaging, and professional
                        way—building trust with audiences, partners, and stakeholders.
                    </p>
                </div>
            </div>

            <div class="row mt-5 d-flex align-items-stretch justify-content-center">

                <!-- CARD 1 -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 mb-4 d-flex">
                    <div class="card service-card d-flex flex-column" style="flex-grow:1; background:#33393f; backdrop-filter:blur(12px); border-radius:2rem;
      box-shadow:0 4px 30px rgba(0,0,0,0.15); overflow:hidden; width:100%;" data-aos="fade-up" data-aos-duration="800"
                        data-aos-delay="100">
                        <div class="card-body px-3 pb-10 pt-10">

                            <h4 class="card-title mb-4 text-secondary text-center">
                                Why Company Profile Video Matters
                            </h4>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Builds a strong first impression
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Communicates brand values and credibility
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Simplifies complex information
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Strengthens corporate branding and reputation
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Supports marketing, presentation, and digital platforms
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- CARD 2 -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 mb-4 d-flex">
                    <div class="card service-card d-flex flex-column" style="flex-grow:1; background:#33393f; backdrop-filter:blur(12px); border-radius:2rem;
      box-shadow:0 4px 30px rgba(0,0,0,0.15); overflow:hidden; width:100%;" data-aos="fade-up" data-aos-duration="800"
                        data-aos-delay="150">
                        <div class="card-body px-3 pb-10 pt-10">

                            <h4 class="card-title mb-4 text-secondary text-center">
                                Why Choose SmilePictures
                            </h4>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Experienced creative team
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    High production quality
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Strategic storytelling approach
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3 mb-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Efficient and collaborative workflow
                                </p>
                            </div>

                            <div class="d-flex align-items-start gap-3">
                                <i class="uil uil-check-circle fs-30 text-secondary flex-shrink-0"></i>
                                <p class="mb-0 text-white">
                                    Brand-focused execution that delivers measurable impact
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </div>
    </section>

    <!-- Our Process Section -->
    <OurProcess2 />

    <!-- Some Of Works Carousel -->
    <SomeOfWorks v-if="!loading" :works="works" :meta="meta" />
</template>

<style>
.wrapper {
    overflow-x: relative;
}

.hero-service-image {
    height: 13rem;
    max-width: 100%;
}

/* Tablet */
@media (max-width: 991.98px) {
    .hero-service-image {
        height: 11rem;
    }
}

/* Mobile */
@media (max-width: 575.98px) {
    .hero-service-image {
        height: 9rem;
    }
}
</style>
